<ng-container *transloco="let t">
    <a
        href="#main-content"
        (click)="focusMainContent($event)"
        class="skip-link"
        >{{ t("shared.link.skip-to-content") }}</a
    >
    <mat-sidenav-container>
        <mat-sidenav #sidenav role="navigation">
            <app-sidenav (sidenavClose)="sidenav.close()"></app-sidenav>
        </mat-sidenav>
        <mat-sidenav-content
            fxFlexFill
            fxLayout="column"
            appScrollScreenDirective
            [class.application-layout]="isApplicationPage"
        >
            <app-header (sidenavToggle)="sidenav.toggle()"></app-header>
            <main fxFlex id="main-content" tabindex="-1">
                <router-outlet></router-outlet>
            </main>
            <app-footer></app-footer>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ng-container>
